<ng-template #templateRef>
  <mat-dialog-content style="max-height: none; height: 100%;">
    <h2 mat-dialog-title>Pick your articles</h2>
    <mat-tab-group>
      <mat-tab label="Graphic">
        <mat-card>
          <form #filterForm="ngForm" (ngSubmit)="filter(filterForm.value)" name="filterForm">
            <mat-card-title>Filter</mat-card-title>
            <mat-card-content>
              <div class="row">
                <div class="col-md-3">
                  <mat-form-field>
                    <input matInput name="Code" ngModel placeholder="Art. code">
                  </mat-form-field>
                </div>
                <div class="col-md-3">
                  <app-dropdown-option [getOnlyId]="true" discriminator="Category" model="ArticleCategory" multiple name="Category"
                                       ngModel placeholder="Category"></app-dropdown-option>
                </div>
                <div class="col-md-3">
                  <mat-form-field>
                    <input matInput name="Barcode" ngModel placeholder="Barcode">
                  </mat-form-field>
                </div>
                <div class="col-md-3">
                  <mat-form-field>
                    <input matInput name="Description" ngModel placeholder="Art. Description">
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <mat-form-field>
                    <input matInput name="CommercialName" ngModel placeholder="Art. Commercial name">
                  </mat-form-field>
                </div>
                <div class="col-md-3">
                  <app-relation-selector #relation (ngModelChange)="setRelation($event)"
                                         [filter]="{include: _Relation.WithoutGoogleMapsInclude}" [ngModel]="Relation"
                                         name="Relation"
                                         placeholder="Relation"></app-relation-selector>
                </div>
                <div class="col-md-3">
                  <mat-form-field>
                    <mat-select multiple name="Groups" ngModel placeholder="Reseller groups">
                      <mat-option *ngFor="let group of Relation?.Groups" [value]="group">{{group.Title}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-3">
                  <mat-form-field>
                    <mat-select [(ngModel)]="showAll" name="showAll">
                      <mat-option [value]="false">Show visible articles by relation</mat-option>
                      <mat-option [value]="true">Show all articles</mat-option>
                    </mat-select>
                    <mat-hint>Which articles are visible depends on the assigned reseller groups of the relation.</mat-hint>
                  </mat-form-field>
                </div>
              </div>
            </mat-card-content>
            <mat-card-actions>
              <app-button (onClick)="pullPriceList(relation.value)" *ngIf="relation?.value" [isLoading]="isSimulating"
                          [title]="relation?.value?.LastPricelist ? 'PriceList last synched on ' + (relation?.value?.LastPricelist | date: 'short') : 'Pull pricelist'" type="button"></app-button>
              <button mat-raised-button color="primary">Filter results</button>
            </mat-card-actions>
          </form>
        </mat-card>
        <div *ngIf="warnForOutdatedPricelist()" class="row mt-1">
          <div class="col-12">
            <p class="p-3 w-100 bg-warning msgbox">
              The prices haven't been refreshed in over a month, make sure you see the most up-to-date prices by syncing the price list again.
            </p>
          </div>
        </div>
        <div *ngIf="warnForNopricelist()" class="row mt-1">
          <div class="col-12">
            <p class="p-3 w-100 bg-danger msgbox">
              Aww, please note there is no price available, please pull the pricelist.
            </p>
          </div>
        </div>
        <div *ngIf="isLoadingList" class="row text-center" style="margin-top: 15px;">
          <div class="col-2 offset-5 text-center">
            <mat-spinner></mat-spinner>
          </div>
        </div>
        <div class="row mt-2">
          <div *ngFor="let promotion of Promotions" class="article-column col-sm-2">
            <mat-card class="align-self-stretch article-card">
              <mat-card-header>
                <mat-card-title><b>{{promotion.getTitle()}}</b></mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div class="newBox">
                  <div *ngIf="!promotion.Type" class="new" i18n>PROMO!</div>
                  <div *ngIf="promotion.Type" [style.background-color]="promotion.Type?.Color"
                       class="new">{{promotion.Type?.getTranslation().toUpperCase()}}
                  </div>
                </div>
                <div class="imageBox">
                  <img src="{{promotion.getImage()}}">
                </div>
                <button (click)="psEditor.edit(promotion)" *ngIf="checkDate(promotion)" class="article-button" mat-raised-button type="button">
                  Order
                </button>
                <button *ngIf="!checkDate(promotion)" disabled i18n mat-raised-button type="button">
                  Available on<br>{{promotion.StartDate | date: 'shortDate'}}
                </button>
              </mat-card-content>
            </mat-card>
          </div>
          <div *ngFor="let article of Articles" class="article-column col-sm-2">
            <mat-card class="align-self-stretch article-card">
              <mat-card-header>
                <mat-card-title><b [matTooltip]="article.Code">{{article.DisplayName}}</b></mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div *ngIf="article.IsNew" class="newBox">
                  <div class="new">NEW!</div>
                </div>
                <div class="imageBox">
                  <img src="{{article.getImage()}}">
                </div>

                <table style="width: 100%">
                  <ng-container *ngIf="article.Children.length === 0; else hasChildren">
                    <ng-container *ngIf="article.Category1?.Id !== '048dd111-025c-4788-93a1-e41ae3d34471'"> <ng-container *ngTemplateOutlet="optionTemplate; context: {$implicit: article}"></ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-template #hasChildren>
                    <ng-container *ngFor="let option of article.Children;">
                      <ng-container *ngTemplateOutlet="optionTemplate; context: {$implicit: option}"></ng-container>
                    </ng-container>
                  </ng-template>

                  <ng-template #optionTemplate let-option>
                    <tr>
                      <td *ngIf="getDeliveryDateAndStock(option) as stock" [class.out-of-stock]="stock.isOOS">
                        <span *ngIf="stock.isOOS && stock.hasNoDate" class="text-danger"
                              matTooltip="This item is currently out of stock">!! </span>
                        <span *ngIf="stock.isOOS && !stock.hasNoDate" class="text-danger"
                              matTooltip="Note: this article is currently not on stock and will be deliverable from {{ stock.inStockDate | date: 'shortDate' }}">!! </span>
                        <span [matTooltip]="option.Code">{{ option.OptionWeight }}{{ option.Unit?.Value }}</span>
                      </td>
                      <td>x{{ option.BatchAmount }}</td>
                      <td>{{ option.Packaging?.Value }}</td>
                      <td>
                        {{ selectedRelation?.PriceList?.Currency?.FreeTextField1 }}
                        {{ option.SalesPrice || option.SalesPrice === 0 ? ((option.SalesPrice ? option.SalesPrice : 0) | number:'1.2-2') : '' }}
                        {{ selectedRelation?.DefaultCurrency?.FreeTextField1 }}
                      </td>
                      <td style="text-align: center;">
                        <ng-container *ngIf="!option.IsUndeliverable else undeliverable">
                          <div *ngIf="getDeliveryDateAndStock(option) as stockInfo"
                               style="display: inline-flex; align-items: center; white-space: nowrap;">

                            <button (click)="toggleQTY(option, -(option.Step ? option.Step : 1))"
                                    [disabled]="getAmount(option) <= 0 || stockInfo.hasNoDate"
                                    class="quantitybutton" color="primary" mat-icon-button
                                    [matTooltip]="!(option.SalesPrice || option.SalesPrice === 0) ? 'No price found' : null">
                              <mat-icon>remove_circle</mat-icon>
                            </button>

                            <mat-form-field style="width: 70px;">
                              <input (blur)="onBlur($event, option)"
                                     [step]="option.Step || 1"
                                     [value]="getAmount(option)"
                                     matInput
                                     placeholder="Amount"
                                     type="number"
                                     style="text-align: center;"
                                     [attr.disabled]="stockInfo.hasNoDate ? true : null">
                            </mat-form-field>

                            <button (click)="toggleQTY(option, (option.Step ? option.Step : 1))"
                                    class="quantitybutton"
                                    color="primary"
                                    mat-icon-button
                                    [disabled]="stockInfo.hasNoDate"
                                    matTooltip="{{!(option.SalesPrice || option.SalesPrice === 0) ? 'No price found' : null}}"
                                    type="button">
                              <mat-icon>add_circle</mat-icon>
                            </button>
                          </div>
                        </ng-container>
                        <ng-template #undeliverable>
                          <mat-icon matTooltip="This article is currently unavailable">warning</mat-icon>
                        </ng-template>
                      </td>
                    </tr>
                  </ng-template>
                </table>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <mat-paginator (page)="pageChange($event);" [length]="filterObject.count"
                           [pageSizeOptions]="[8, 16, 24, 48, 96]" [pageSize]="filterObject.limit"></mat-paginator>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Scan Codes">
        <div class="row">
          <div class="col-md-12">
            <app-relation-selector (ngModelChange)="setRelation($event)"
                                   [filter]="{include: _Relation.WithoutGoogleMapsInclude, where: {SubTypeId: {neq: 'dbb215a5-150d-4691-be05-c79a84dccfc5'}}}" [ngModel]="Relation"
                                   name="Relation"
                                   placeholder="Relation"></app-relation-selector>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <mat-form-field>
              <input [(ngModel)]="Scan" matInput name="Code" placeholder="Art. code">
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button (click)="addByArticleCode()" color="primary" mat-raised-button style="width: 100%">Scan</button>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Shopping cart ({{getTotalCount()}})">
        <form #editorForm="ngForm" id="articleEditor" name="editRelation">
          <table class="mat-table mat-elevation-z8">
            <thead>
            <tr class="mat-header-row">
              <th class="mat-header-cell">Article</th>
              <th class="mat-header-cell">Ordered</th>
              <th
                class="mat-header-cell">{{ selectedRelation?.PriceList?.Currency?.FreeTextField1 ? selectedRelation?.PriceList?.Currency?.FreeTextField1 : '€' }}
                /unit
              </th>
              <th class="mat-header-cell">Discount</th>
              <th class="mat-header-cell">Discount Reason</th>
              <th class="mat-header-cell">Date in stock</th>
              <th class="mat-header-cell pull-right">Line Total</th>
              <th class="mat-header-cell pull-right" style="flex: none; width: 30px;"></th>
            </tr>
            </thead>
            <tbody>
            <tr #ngGroup="ngModelGroup" *ngFor="let line of Selected; let i = index;"
                [ngModelGroup]="line.randomNumber"
                class="mat-row">
              <td class="mat-cell">{{ line.Article?.CommercialName }}</td>

              <td class="mat-cell" *ngIf="getDeliveryDateAndStock(line.Article) as stockInfo">
                <button (click)="toggleQTY(line.Article, -(line.Article.Step ? line.Article.Step : 1))"
                        [disabled]="getAmount(line.Article) <= 1 || stockInfo.hasNoDate"
                        class="quantitybutton"
                        color="primary"
                        mat-icon-button
                        style="padding: 5px;"
                        type="button">
                  <mat-icon>remove</mat-icon>
                </button>
                <mat-form-field style="width: 65px;">
                  <input (blur)="onBlur($event, line.Article, false)"
                         [step]="line.Article?.Step || 1"
                         [value]="getAmount(line.Article)"
                         matInput
                         placeholder="Amount"
                         type="number"
                         [attr.disabled]="stockInfo.hasNoDate ? true : null">
                </mat-form-field>
                <button (click)="toggleQTY(line.Article, (line.Article.Step ? line.Article.Step : 1))"
                        [disabled]="stockInfo.hasNoDate"
                        class="quantitybutton"
                        color="primary"
                        mat-icon-button
                        style="padding: 5px;"
                        type="button">
                  <mat-icon>add</mat-icon>
                </button>
              </td>

              <td class="mat-cell">
                {{ line.Article ? ((selectedRelation?.PriceList?.Currency?.FreeTextField1 ? selectedRelation?.PriceList?.Currency?.FreeTextField1 : '€') + ' ' + (line.Article?.SalesPrice | number:'1.2-2') + '/' + line.Article?.Packaging?.Value) : '' }}
              </td>
              <td class="mat-cell">
                <mat-form-field>
                  <input (ngModelChange)="line.Discount = $event / 100" [ngModel]="line.Discount * 100" matInput
                         name="Discount" placeholder="Discount" type="number">
                  <span matSuffix>%</span>
                </mat-form-field>
              </td>
              <td class="mat-cell">
                <app-dropdown-option [(ngModel)]="line.DiscountReason" [disabled]="!line.Discount"
                                     [required]="line.Discount" discriminator="DiscountReason"
                                     model="DocumentLine" name="DiscountReason" placeholder="Discount Reason">
                </app-dropdown-option>
              </td>

              <td class="mat-cell" *ngIf="getDeliveryDateAndStock(line.Article) as stock">
                <span *ngIf="stock.isOOS && !stock.hasNoDate" class="text-danger" style="font-weight: bold;">
                  {{ stock.inStockDate | date: 'shortDate' }}
                </span>
                <span *ngIf="stock.isOOS && stock.hasNoDate" class="text-muted"
                      style="font-style: italic; font-size: 12px;">
                Unknown
              </span>
              </td>

              <td class="mat-cell pull-right">
                {{ selectedRelation?.PriceList?.Currency?.FreeTextField1 ? selectedRelation?.PriceList?.Currency?.FreeTextField1 : '€' }}
                {{ line.Ordered * (line.Article ? line.Article?.SalesPrice : 0) * (1 - line.Discount) | number: '1.2-2' }}
              </td>
              <td class="mat-cell pull-right" style="flex: none; width: 30px;">
                <button (click)="Selected.splice(Selected.indexOf(line), 1)" mat-icon-button type="button">
                  <mat-icon>
                    delete
                  </mat-icon>
                </button>
                <button *ngIf="line.Promotion" mat-icon-button
                        matTooltip="{{line.Promotion.getTitle()}}: {{line.Promotion.StartDate | date:'shortDate'}} - {{line.Promotion.EndDate | date:'shortDate'}}"
                        type="button">
                  <mat-icon>local_parking</mat-icon>
                </button>
              </td>
            </tr>
            <!-- Show the entered promocodes -->
            <tr *ngFor="let code of PromotionCodes" class="mat-row">
              <td class="mat-cell">{{ code.Article?.Description }}</td>
              <td class="mat-cell">1</td>
              <td class="mat-cell"></td>
              <td class="mat-cell"></td>
              <td class="mat-cell"></td>
              <td class="mat-cell pull-right"></td>
              <td class="mat-cell pull-right" style="flex: none; width: 30px;"></td>
            </tr>

            <!-- Enter a new promocode -->
            <tr class="mat-row">
              <td class="mat-cell"></td>
              <td class="mat-cell"></td>
              <td class="mat-cell"></td>
              <td class="mat-cell"></td>
              <td class="mat-cell">
              </td>
              <td class="mat-cell pull-right">
                <mat-form-field>
                  <input #promoCode matInput name="PromoCode" placeholder="Promotion code">
                  <button (click)="addPromotionCode(promoCode.value)" mat-button matSuffix type="button">Add</button>
                </mat-form-field>
              </td>
              <td class="mat-cell pull-right" style="flex: none; width: 30px;">
              </td>
            </tr>

            <tr class="mat-row">
              <td class="mat-cell"></td>
              <td class="mat-cell"></td>
              <td class="mat-cell"></td>
              <td class="mat-cell"></td>
              <td class="mat-cell pull-right">
                <b>Totaal: </b>
              </td>
              <td class="mat-cell pull-right">
                <b>{{ selectedRelation?.PriceList?.Currency?.FreeTextField1 }} {{ getTotalAmount() | number: '1.2-2' }}</b>
              </td>
              <td class="mat-cell pull-right" style="flex: none; width: 30px;"></td>
            </tr>
            </tbody>
          </table>
        </form>
      </mat-tab>
    </mat-tab-group>
    <mat-dialog-actions>
      <div class="fill-remaining-space"></div>
      <button mat-button mat-dialog-close mat-raised-button type="button">Close</button>
      <app-button (onClick)="save()" [disabled]="!editorForm.form.valid || Selected.length === 0" [isLoading]="isLoading"></app-button>
    </mat-dialog-actions>
  </mat-dialog-content>
</ng-template>

<ng-template #infoTemplateRef>
  <form #editorForm="ngForm" id="accountEditor" name="editAccount">
    <button (click)="_Dialog.getDialogById(this.infoDialogRef.id).close();currentHover = null" color="primary" mat-icon-button style="float: right;" type="button">
      <mat-icon>
        close
      </mat-icon>
    </button>
    <h2 mat-dialog-title>{{currentHover ? currentHover.CommercialName : ''}}</h2>
    <mat-dialog-content *ngIf="currentHover">
      <div class="row">
        <div class="col-sm-4">
          <div *ngIf="currentHover.IsNew" class="new">NEW!</div>
          <img src="{{currentHover.getImage()}}" style="width: 100%">
        </div>
        <div class="col-sm-8">
          <b>Code:</b> {{currentHover.Code}}<br>
          <b>MinQTY:</b> {{currentHover.MinQTY}}<br>
          <b>SalesPrice:</b> € {{currentHover.SalesPrice}}<br>
          <b>Stock:</b> {{(currentHover.InStockDate ? 'In stock: ' + (currentHover.InStockDate | date:'shortDate') : 'In stock')}}
          <table style="width: 100%">
            <tr *ngFor="let option of article.Children;">
              <td>{{option.OptionWeight}}{{option.Unit?.Value}}</td>
              <td>x{{option.BatchAmount}}</td>
              <td>{{option.Packaging?.Value}}</td>
              <td> {{option.SalesPrice || option.SalesPrice === 0 ?
                (selectedRelation?.PriceList?.Currency?.FreeTextField1 + ((option.SalesPrice ? option.SalesPrice : 0) | number:'1.2-2')) : ''}}
              </td>
              <td style="text-align: right;">
                <button (click)="option.SalesPrice || option.SalesPrice === 0 ? toggleQTY(option, -(option.Step ? option.Step : 1)) : false"
                        [disabled]="!(option.SalesPrice || option.SalesPrice === 0) || getAmount(option) <= 0" class="quantitybutton" color="primary"
                        mat-icon-button
                        matTooltip="{{!(option.SalesPrice || option.SalesPrice === 0) ? 'No price found' : null}}"
                        type="button">
                  <mat-icon>
                    remove_circle
                  </mat-icon>
                </button>
                <mat-form-field style="width: 65px;">
                  <input (blur)="onBlur($event, option)" [step]="option.Step || 1" [value]="getAmount(option)" matInput placeholder="Amount" type="number">
                </mat-form-field>
                <button (click)="option.SalesPrice || option.SalesPrice === 0 ? toggleQTY(option, (option.Step ? option.Step : 1)) : false" [disabled]="!(option.SalesPrice || option.SalesPrice === 0)"
                        class="quantitybutton" color="primary" mat-icon-button
                        matTooltip="{{!(option.SalesPrice || option.SalesPrice === 0) ? 'No price found' : null}}"
                        type="button">
                  <mat-icon>
                    add_circle
                  </mat-icon>
                </button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </mat-dialog-content>
  </form>
</ng-template>
<app-promotion-selector-editor #psEditor [Relation]="selectedRelation" (ListChange)="addToCart($event)"></app-promotion-selector-editor>
